import {React, useState} from 'react';
import './empresa.css';
import { InputMask } from '@react-input/mask';
import Alert from "@mui/material/Alert";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import api from '../../services/api';
import Loading from "../Layout/Loading";
import { useNavigate } from 'react-router-dom';

function Empresa(props) {

    //#region constantes
    const navigate = useNavigate();
    
    const [showLoading, setShowLoading] = useState(false);
    const [msgErro, setMsgErro] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [empresa, setEmpresa] = useState({});
    //#endregion

    

    //#region functions
    function changeCNPJ(e){
        setMsgErro("");
        setCnpj(e.target.value);
    }

    function Avancar(){

        if (!cnpj){
            setMsgErro("CNPJ não informado, operação não permitida!");
            return;
        }
        setShowLoading(true);

        setTimeout(() => {
            api.get("cadastro/empresapodeemitirtaxacusteio", {
                                                                params: {
                                                                    cnpj: cnpj
                                                                }
                                                            })
                .then((resp) => {
                    setEmpresa(resp.data);
                    setShowLoading(false);

                    const dados = {
                        ID_EMPRESA: resp.data.ID_EMPRESA
                    };

                    navigate("/menuextrato", { state: dados });
                })
                .catch((err) => {
                    if (err.response.data.RESULT){
                        setMsgErro(err.response.data.RESULT);
                    }else{
                        setMsgErro(err.response.data);
                    }
                    setCnpj("");
                    setShowLoading(false);
                });
        }, 500);
    }
    //#endregion 



    //#region html
    return(

        <>
            {
                (props.slogan) ? (
                    <div className="cnpjcpf-container_" 
                        style={{padding:"10px 10px 0 10px",
                        textAlign:'center'}}>

                        {!showLoading ? (
                            <div className="base-card_ cnpjcpf-card_ form-control">

                                <div className="cnpjcpf-content-container">

                                    <h1>{props.slogan}</h1>
                                    <div className="cnpjcpf-title">
                                        <h3>Emissão de Taxa de custeio</h3>
                                    </div>

                                    <div className="cnpj-cpf-container" style={{backgroundColor:'#fff'}}>
                                    
                                        <div className="cnpjcpf-pessoa-jurídica_" 
                                                style={{backgroundColor:'#fff',
                                                        width:'80%',
                                                        margin:'0.5rem 0 0.5rem 0'}} >
                                            <h6>CNPJ da empresa:</h6>
                                            <InputMask mask="__.___.___/____-__" 
                                                        replacement={{ _: /\d/ }} 
                                                        showMask={false}
                                                        id="edtCNPJ"
                                                        name="edtCNPJ"
                                                        placeholder='CNPJ da empresa'
                                                        inputMode='numeric'
                                                        style={{width:'200px'}}
                                                        onChange={changeCNPJ}/>

                                            <div style={{marginTop:'3rem',backgroundColor: '#fff',height:'50px'}}>
                                                <button className="btn btn-padrao"
                                                        disabled={showLoading}
                                                        style={{width:'150px'}}
                                                        onClick={Avancar}>
                                                    Avançar
                                                </button>
                                            </div>
                                            
                                            {
                                                (msgErro) ? (
                                                    <Alert icon={<WarningAmberIcon />}
                                                            severity="warning"
                                                            style={{ marginTop: "0rem" }}>
                                                        {msgErro}
                                                    </Alert>

                                                ) : null
                                            }
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) :  <Loading />}

                    </div>
                ) : null
            }
        </>

    )
    //#endregion 
};

export default Empresa;